import helpCenter from "@icons/help_center.svg";
import close from "@icons/close.svg";

export default class HelpHandler {
  text: HTMLElement;
  button: HTMLElement;
  opened = false;

  constructor(el: HTMLElement) {
    this.button = el;
    this.text = el.closest(".tile").querySelector("[data-help-content]");
    this.button.addEventListener("click", () => {
      this.toggle();
    });
  }

  toggle() {
    if (this.opened) {
      this.opened = false;
      this.button.querySelector(".ma-icon").innerHTML = helpCenter;
      this.text.classList.remove("toggled");
    } else {
      this.button.querySelector(".ma-icon").innerHTML = close;
      this.opened = true;
      this.text.classList.add("toggled");
    }
  }
}
